import { AlertTriangle, CheckCircle2, Circle, Loader2, Lock, XCircle } from "lucide-react";
import { fmt } from "./util";

const ICON = {
  done: <CheckCircle2 className="w-5 h-5 text-emerald-600" />,
  ready: <CheckCircle2 className="w-5 h-5 text-[#c9a13b]" />,
  in_progress: <Loader2 className="w-5 h-5 text-sky-600 animate-spin" />,
  action: <AlertTriangle className="w-5 h-5 text-amber-600" />,
  failed: <XCircle className="w-5 h-5 text-red-600" />,
  problem: <XCircle className="w-5 h-5 text-red-600" />,
  blocked: <Lock className="w-5 h-5 text-amber-600" />,
  todo: <Circle className="w-5 h-5 text-slate-300" />,
};
const TEXT = { done: "Done", ready: "Ready to publish", in_progress: "In progress", action: "Action needed", failed: "Failed", problem: "Needs attention", blocked: "Not available yet", todo: "Not started" };

export function Tracker({ steps }) {
  return (
    <ol className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2" data-testid="domain-tracker">
      {steps.map((s, i) => (
        <li key={s.key} className={`rounded-xl border p-3 ${s.status === "done" ? "border-emerald-200 bg-emerald-50/60" : "border-slate-200 bg-white"}`} data-testid={`tracker-${s.key}`}>
          <div className="flex items-center gap-2">{ICON[s.status] || ICON.todo}<span className="text-[11px] text-slate-400">Step {i + 1}</span></div>
          <p className="font-semibold text-sm mt-1 text-[#062a20]">{s.label}</p>
          <p className="text-xs text-slate-600" data-testid={`tracker-${s.key}-status`}>{TEXT[s.status] || s.status}</p>
          {s.at && <p className="text-[11px] text-slate-400 mt-0.5">{fmt(s.at)}</p>}
        </li>))}
    </ol>);
}
